import { forwardRef, type SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Styled `<select>` (OG `.v16-select` with the custom chevron). Native control,
 * but appearance-stripped and dressed to match the dark form language of `Input`,
 * with a lucide chevron overlaid so it never reads as a raw browser dropdown.
 */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          'h-11 w-full cursor-pointer appearance-none rounded-md border border-card-line bg-input px-4 pr-10 text-sm text-hi outline-none transition-colors',
          'focus:border-accent focus:ring-2 focus:ring-[var(--winr-accent-soft)]',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        size={16}
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-mid"
      />
    </div>
  ),
);
Select.displayName = 'Select';
